import {observe} from '@github-ui/selector-observer'
import {updateContent, reload} from '@github-ui/updatable-content'
import {SOFT_NAV_STATE} from '@github-ui/soft-nav/states'
import {on} from 'delegated-events'
import {fetchPoll} from '@github-ui/fetch-utils'
import verifySsoSession from '../sso'
import {toggleDetailsTarget} from '../behaviors/details'
import {TemplateInstance} from '@github/template-parts'
import {remoteForm} from '@github-ui/remote-form'
import {getBaseFetchHeaders} from '@github-ui/fetch-headers'

function updateContentOnSoftNavigations() {
  const elementsToUpdate = document.querySelectorAll<HTMLElement>('.js-pull-refresh-on-pjax')
  for (const el of elementsToUpdate) {
    updateContent(el)
  }
}

function updateContentOnTurboRestore() {
  const elementsToRefresh = document.querySelectorAll<HTMLElement>('[data-refresh-on-turbo-restored="true"]')
  for (const el of elementsToRefresh) {
    updateContent(el)
  }
}

document.addEventListener(SOFT_NAV_STATE.SUCCESS, updateContentOnSoftNavigations)
document.addEventListener('turbo:restored', updateContentOnTurboRestore)

function showFlash(message: string, detailsElement: HTMLElement): void {
  const template = document.querySelector<HTMLTemplateElement>('template.js-flash-template')!
  template.after(new TemplateInstance(template, {className: 'flash-error', message}))

  detailsElement.removeAttribute('open')
}

on('click', '.js-change-base-form-button', async function (event) {
  event.preventDefault()

  // disable button and show loading spinner
  const button = event.currentTarget as HTMLButtonElement
  const spinner = button.querySelector('.js-change-base-spinner') as HTMLSpanElement
  button.disabled = true
  spinner.style.display = 'inline'

  await verifySsoSession()

  const details = (event.target as HTMLElement).closest<HTMLElement>('details')!
  try {
    const form = button.form as HTMLFormElement
    const response = await fetch(form.action, {
      method: form.method,
      body: new FormData(form),
      headers: {
        ...getBaseFetchHeaders(),
        Accept: 'application/json',
      },
    })
    const responseData = await response.json()

    toggleDetailsTarget(document.querySelector('.js-pull-header-details')!, {force: false})
    if (!response.ok) {
      showFlash(responseData.error_message, details)
      return
    }

    let url = null
    if (responseData.job) {
      url = responseData.job.url
    } else {
      url = responseData.orchestration.url
    }
    const pollingData = await (await fetchPoll(url, {headers: {accept: 'application/json'}})).json()
    if (pollingData.orchestration) {
      if (pollingData.orchestration.error_message) {
        showFlash(pollingData.orchestration.error_message, details)
      } else {
        return reload()
      }
    } else if (pollingData.job.error_message) {
      showFlash(pollingData.job.error_message, details)
    } else {
      return reload()
    }
  } catch {
    // eslint-disable-next-line i18n-text/no-en
    showFlash('An unknown error occured.', details)
  }
})

function showUpdateBranchError(message: string, form: HTMLElement, currentSha: string): void {
  const target = form.closest('.js-pull-merging')
  if (!target) return

  target.classList.add('is-error')

  const errorTextContainer = target.getElementsByClassName('merge-branch-description')[0] as HTMLElement
  errorTextContainer.textContent = message

  const expectedHeadOid = target.querySelector<HTMLInputElement>("input[name='expected_head_oid']")
  if (!expectedHeadOid) return
  expectedHeadOid.value = currentSha
}

remoteForm('.js-update-branch-async-button', async function (form, wants) {
  await verifySsoSession()
  try {
    const response = await wants.json()

    const pollingData = await (
      await fetchPoll(response.json.orchestration.url, {headers: {accept: 'application/json'}})
    ).json()
    if (pollingData.orchestration.error_message) {
      showUpdateBranchError(pollingData.orchestration.error_message, form, pollingData.orchestration.current_head_sha)
    } else {
      // TODO(dzader): this isn't a great experience should probably make it better
      if (form.getElementsByClassName('js-update-branch-type')[0]?.getAttribute('value') === 'rebase') {
        return reload()
      }
    }
  } catch {
    // eslint-disable-next-line i18n-text/no-en
    showUpdateBranchError('An unknown error occured.', form, '')
  }
})

observe('.js-updating-pull-request-commits-count', {
  add(el) {
    const countText = el.textContent
    const updateableCounts = document.querySelectorAll('.js-updateable-pull-request-commits-count')
    for (const count of updateableCounts) {
      count.textContent = countText
    }
  },
})
